/**
 * Shell/rail state shared by PnidWorkspaceShell (which owns the collapse
 * toggle, now that it lives on the frame bar) and PnidNavigationRail (which
 * renders against it). Kept out of both components so each module exports only
 * its component and React Fast Refresh keeps working.
 */

/** Collapse choice survives reloads; storage can throw in private windows. */
export const RAIL_COLLAPSED_KEY = 'pnid_rail_collapsed';

/* Collapsed is the DEFAULT: the rail is navigation, and the pages it leads to
   are drawings and tables that want the width. Only an explicit expand is
   remembered — an absent value means collapsed. */
export function readStoredCollapsed(): boolean {
  try {
    return localStorage.getItem(RAIL_COLLAPSED_KEY) !== '0';
  } catch {
    return true;
  }
}

export function storeCollapsed(collapsed: boolean) {
  try {
    localStorage.setItem(RAIL_COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    /* Session-only preference when storage is unavailable. */
  }
}

/** One label for the unscoped state, shared by the tile, the bar and the menu. */
export const ALL_PLANTS_LABEL = 'All Plants';

export function routeIsActive(currentPath: string, targetPath: string) {
  if (targetPath === '/drawings') return currentPath === '/drawings' || currentPath.startsWith('/pnid/');
  if (targetPath === '/work') return currentPath === '/work' || currentPath.startsWith('/packages/');
  return currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
}

/* Deliberately asymmetric with accountLabel(), which does not title-case. */
export function tenantLabel(userGroup?: string) {
  const value = userGroup?.trim();
  if (!value) return 'Raven';
  if (value === 'sme_demo_group') return 'SME Demo';
  return value
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}
